import React from "react";
import { Grid, Divider, Box } from "@material-ui/core";
import {
  MasterButton,
  InputTextMaster,
  InputOptionMaster,
  InputReactDatepicker,
  ModalExportList,
} from "App/Component/ui";
import {
  getByFilterBookingAntrianExport,
  statusBookingList,
  statusRmList,
  useScehuldeDokter,
} from ".";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useState } from "react";
import { useSelector } from "react-redux";
export default function FormFilterBookingAntrian({
  formFilter,
  setFormFilter,
  setNewData,
  withExportButton = false,
  resetPagination,
}) {
  const [showModalExportList, setShowModalExportList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formFilter.dates === "") {
      return defaultToastError("Tanggal tidak boleh kosong");
    }
    await setNewData(1, 10);
    resetPagination();
  };

  const master = useSelector(({ master }) => master);

  const scheduleDokter = useScehuldeDokter(formFilter.doctor_id);

  const handleExport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await getByFilterBookingAntrianExport(formFilter);
      if (res.state) {
        defaultToastSuccess(
          "Berhasil, mohon menunggu data sedang dieksport..."
        );
      } else {
        defaultToastError(res.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={2}>
          <Grid item sm={3}>
            <InputTextMaster
              name="idbooking"
              label="ID BOOKING"
              id="idbooking"
              value={formFilter.idbooking}
              placeholder="ID Booking"
              onChange={handleChange("idbooking")}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="doctor_id"
              label="DOKTER"
              id="doctor_id"
              withSearch={true}
              data={master.dokter.list_select}
              labelValue={formFilter.doctor_name}
              value={formFilter.doctor_id}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    doctor_id: null,
                    doctor_name: "Pilih Dokter",
                    schedule_doctor_id: "",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    doctor_id: e.value,
                    doctor_name: e.label,
                    schedule_doctor_id: "",
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="schedule_doctor_id"
              label="SCHEDULE DOKTER"
              id="schedule_doctor_id"
              withSearch={false}
              needParse={false}
              data={scheduleDokter}
              value={formFilter.schedule_doctor_id}
              onChange={handleChange("schedule_doctor_id")}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="mobileonsite"
              label="STATUS REGISTRASI"
              id="mobileonsiteStatus"
              needParse={false}
              withSearch={false}
              data={[
                {
                  label: "Semua",
                  value: 0,
                },
                {
                  label: "Belum Registrasi",
                  value: 1,
                },
                {
                  label: "Sudah Registrasi",
                  value: 2,
                },
              ]}
              value={formFilter.status}
              onChange={(e) =>
                setFormFilter({ ...formFilter, status: e.target.value })
              }
            />
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name="name"
              label="NAMA"
              id="name"
              placeholder="Nama"
              value={formFilter.name}
              onChange={handleChange("name")}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="mobileonsite"
              label="ASAL BOOKING"
              id="mobileonsite"
              withSearch={false}
              data={[
                {
                  label: "Semua",
                  value: 0,
                },
                {
                  label: "Onsite",
                  value: 2,
                },
                {
                  label: "Mobile",
                  value: 1,
                },
                {
                  label: "JKN",
                  value: 3,
                },
              ]}
              value={formFilter.mobileonsite}
              onChange={handleChange("mobileonsite")}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="insurance_id"
              label="ASURANSI"
              id="insurance_id"
              withSearch={true}
              data={master.asuransi.list_select}
              value={formFilter.insurance_id}
              labelValue={formFilter.insurance_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    insurance_id: "",
                    insurance_name: "Pilih Asuransi",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    insurance_id: e.value,
                    insurance_name: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.first_date}
              label="TANGGAL"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  first_date: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  first_date: e,
                  finish_date: new Date(e),
                })
              }
              withPeriode={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "1px solid #EAEAEA",
                  background: "#fff",
                  padding: "0 0.8rem 0 0.8rem",
                  cursor: "pointer",
                  // borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                s/d
              </button>
              <InputReactDatepicker
                selected={formFilter.finish_date}
                label=""
                minDate={new Date(formFilter.first_date)}
                handleChangeToday={(e) =>
                  setFormFilter({
                    ...formFilter,
                    finish_date: e,
                  })
                }
                onChange={(e) =>
                  setFormFilter({
                    ...formFilter,
                    finish_date: e,
                  })
                }
                withParentPeriode={true}
              />
            </InputReactDatepicker>
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="status_booking"
              label="STATUS BOOKING"
              id="status_booking"
              withSearch={false}
              needParse={false}
              data={statusBookingList}
              value={formFilter.status_booking}
              onChange={handleChange("status_booking")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="status_rm"
              label="STATUS RM"
              id="status_rm"
              withSearch={false}
              needParse={false}
              data={statusRmList}
              value={formFilter.status_rm}
              onChange={handleChange("status_rm")}
            />
          </Grid>
        </Grid>
        <br />

        <div
          className="mt-1"
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Box sx={{ display: "flex", gap: "16px" }}>
            {withExportButton && (
              <>
                <MasterButton
                  type={"button"}
                  color="primary-cyan"
                  name={"Export List"}
                  size="md"
                  onClick={() => setShowModalExportList(!showModalExportList)}
                />

                <MasterButton
                  type={"button"}
                  color="warning"
                  name={isLoading ? "Loading..." : "EXPORT"}
                  disabled={isLoading}
                  size="md"
                  onClick={handleExport}
                />
              </>
            )}
            <MasterButton
              name={"CARI"}
              type="submit"
              outline={true}
              color={"green"}
              size={"md"}
            />
          </Box>
        </div>

        <br />
        <Divider />
      </form>

      {showModalExportList && (
        <ModalExportList
          title={"Export List Booking Antrian"}
          showModal={() => setShowModalExportList(false)}
          type="booking_antrian"
        />
      )}
    </>
  );
}
